import React from 'react'
import "../styles/PageNotFound.css";


const PageNotFound = () => {
  return (
    <div className='container pagenotfound-container'>
      <h1 className='error404'>404</h1>
      <h1 className='pagenotfound'> Ooops, page not found :(</h1>
      <h3 className='sorry'>Sorry, but the requested page does not exist or an error occured. </h3>
    </div>
  )
}

export default PageNotFound
